<template>
    <Overlay :show="showLoading">
        <b-row>
            <b-col md="6" lg="6">
                <b-card title="User interface">
                    <validation-observer ref="generalInfo">
                        <b-form-group
                            :label="$t('Component(Label):name')"
                            label-for="name"
                        >
                            <validation-provider
                                #default="{ errors }"
                                :name="$t('Component(Label):name')"
                                rules="required"
                            >
                                <b-form-input
                                    :state="errors.length > 0 ? false:null"
                                    id="name"
                                    disabled
                                    v-model="ui.title"
                                    :placeholder="$t('Component(Placeholder):name')"
                                />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>

                        <b-form-group
                            :label="$t('Component(Label):route')"
                            label-for="name"
                        >
                            <validation-provider
                                #default="{ errors }"
                                :name="$t('Component(Label):route')"
                                rules="required"
                            >
                                <b-form-input
                                    :state="errors.length > 0 ? false:null"
                                    id="name"
                                    disabled
                                    v-model="ui.attributes.route"
                                    :placeholder="$t('Component(Placeholder):route')"
                                />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </validation-observer>
                </b-card>
            </b-col>
            <b-col md="6" lg="6">
                <b-card title="Visibility settings">
                    <b-form-group
                        :label="$t('Component(Label):applications')"
                        label-for="applications"
                    >
                        <v-select
                            v-model="ui.applications"
                            multiple
                            id="applications"
                            :placeholder="$t('Component(Placeholder):applications')"
                            :options="applications"
                        />
                    </b-form-group>
                    <b-form-checkbox
                        id="sandboxEnabled"
                        checked="true"
                        name="check-button"
                        class="mb-1"
                        switch
                        inline
                        v-model="ui.isSubscriptionRequired"
                    >
                        {{ $t('Component(Label):is-subscription-required') }}
                    </b-form-checkbox>
                </b-card>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <div class="demo-inline-spacing float-right">
                    <Button
                        variant="success"
                        class="mt-0"
                        @click="save"
                    >
                        {{ $t('Component(Button):save') }}
                    </Button>
                    <Button
                        variant="dark"
                        class="mt-0"
                        @click="close"
                    >
                        {{ $t('Component(Button):close') }}
                    </Button>
                </div>
            </b-col>
        </b-row>
    </Overlay>
</template>

<script>
import {Button} from "@core/components/common";
import {BRow, BCol, BFormGroup, BFormInput, BCard, BCardTitle, BFormCheckbox} from 'bootstrap-vue';
import Overlay from "@core/components/common/Overlay";
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {SystemApi} from "@core/api";
import backendResponse from "@core/mixins/ui/backend-response";
import {required} from '@validations'
import vSelect from 'vue-select'
import {Application} from "@/libs/application";

export default {
    mixins: [backendResponse],
    components: {
        Overlay, BRow, BCol, ValidationProvider, ValidationObserver, BFormGroup, BFormInput, BCard, BCardTitle,
        Button, vSelect, BFormCheckbox
    },
    props: {
        id: {
            default: null
        }
    },
    data() {
        return {
            showLoading: true,
            ui: {
                title: '',
                type: 'page',
                attributes: {route: ''},
                applications: [],
                isSubscriptionRequired: false
            },
            applications: Application.all(),
            required
        };
    },
    methods: {
        save() {
            this.showLoading = true;
            SystemApi.security
                .saveUserInterface(this.id, this.ui)
                .then(() => this.showDefaultSuccessMessage('User interface has been updated'))
                .catch(this.handleBackendError)
                .finally(() => this.showLoading = false);
            ;
            // this.$refs.generalInfo.validate().then(isValid => {
            //     if (isValid) {
            //         SystemApi.security
            //             .addUserInterface(this.ui.title, this.ui.type, this.ui.attributes)
            //             .then(r => {
            //                 this.showDefaultSuccessMessage('User interface has been successfully saved');
            //                 this.close();
            //             })
            //             .catch(this.handleBackendError)
            //     }
            // });
        },
        close() {
            this.$router.go(-1);
        }
    },
    created() {
        SystemApi.security
            .getUserInterfaceCard(this.id)
            .then(r => this.ui = r.data)
            .finally(() => this.showLoading = false);
    }
}
</script>

<style scoped>

</style>
